import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetSingleCustomer = (params: any) =>
    request({
        url: ApiURL.Query.GetSingleCustomer + '/' + params,
        method: RequestType.GET,
    });

const GetCustomerById = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerById + '/' + params,
        method: RequestType.GET,
    });
const GetAcountListByCustomerId = (params: any) =>
    request({
        url: ApiURL.Query.GetAcountListByCustomerId + '/' + params,
        method: RequestType.GET,
    });

const GetBankAccount = (params: any) =>
    request({
        url: ApiURL.Query.GetBankAccount,
        method: RequestType.GET,
        params: params,
    });

const GetCustomerRiskStatusByCustomerId = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerRiskStatusByCustomerId + '/' + params,
        method: RequestType.GET,
    });

const GetCustomerOptInByCustomerId = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerOptInByCustomerId,
        method: RequestType.GET,
        params: params,
    });

const GetCustomerReturnList = (data: any) =>
    request({
        url: ApiURL.Query.GetCustomerReturnList,
        method: RequestType.POST,
        data: data,
    });

const GetGiftCardDatas = (data: any) =>
    request({
        url: ApiURL.Query.GetGiftCardDatas,
        method: RequestType.POST,
        data: data,
    });

const GetGiftCardTransactionDatas = (data: any) =>
    request({
        url: ApiURL.Query.GetGiftCardTransactionDatas,
        method: RequestType.POST,
        data: data,
    });

const GetReturnDetailByReturnId = (params: any) =>
    request({
        url:
            ApiURL.Query.GetReturnDetailByReturnId +
            '/?CustomerId=' +
            params.customerId +
            '&ReturnId=' +
            params.returnId,
        method: RequestType.GET,
    });

const GetCustomerContactMessageList = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerContactMessageList + '/?CustomerId=' + params,
        method: RequestType.GET,
        params: params,
    });

const GetCustomerContactMessageById = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerContactMessageById,
        method: RequestType.GET,
        params: params,
    });

const GetRptTopic = () =>
    request({
        url: ApiURL.Query.GetRptTopic,
        method: RequestType.GET,
    });

const GetRptSubTopics = () =>
    request({
        url: ApiURL.Query.GetRptSubTopics,
        method: RequestType.GET,
    });

const GetCustomerDeviceDetails = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerDeviceDetails,
        method: RequestType.GET,
        params: params,
    });

const GetCustomerSubMenuFromRule = () =>
    request({
        url: ApiURL.Query.GetCustomerSubMenuFromRule,
        method: RequestType.GET,
    });

const GetCustomer = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerManagementCustomer + '?' + params,
        method: RequestType.GET,
    });
const GetCustomerAccountHistory = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerAccountHistory,
        method: RequestType.GET,
        params: params,
    });

const DisableLcwMoneyTransfer = (params: { customerId: number }) =>
    request({
        url: ApiURL.Query.DisableLcwMoneyTransfer,
        method: RequestType.GET,
        params: params,
    });

const CustomerQuery = {
    GetSingleCustomer,
    GetAcountListByCustomerId,
    GetCustomerRiskStatusByCustomerId,
    GetCustomerById,
    GetCustomerOptInByCustomerId,
    GetCustomerReturnList,
    GetReturnDetailByReturnId,
    GetGiftCardDatas,
    GetGiftCardTransactionDatas,
    GetBankAccount,
    GetCustomerContactMessageList,
    GetCustomerContactMessageById,
    GetRptTopic,
    GetRptSubTopics,
    GetCustomerDeviceDetails,
    GetCustomerSubMenuFromRule,
    GetCustomer,
    GetCustomerAccountHistory,
    DisableLcwMoneyTransfer,
};

export default CustomerQuery;
